import styled from 'styled-components'
import { ChatDiscussion } from '@components/Chat'
import { Pill } from '@components/Pill'
import { radii } from '@/theme/tokens'

/** The idea's Thumbnail, as its page's visual anchor. */
export const HeroImage = styled.img`
	width: 100%;
	max-height: 320px;
	object-fit: cover;
	border-radius: ${radii.inner};
	display: block;
`

export const CategoryPill = styled(Pill).attrs({ $tone: 'soft', $size: 'md' })``

/** The idea's Discussion, under its card. */
export const Discussion = styled(ChatDiscussion)`
	margin-top: 24px;
`
